 import { AddNewProduct } from '@/models/add-new-product/add-new-product';
import { ProductVariantDetails } from '@/models/product-variant-details/product-variant-details';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthStateService } from '@guards/auth-state.service';
import { AppService } from '@services/app.service';
import { ConfigService } from '@services/config.service';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import * as bootstrap from 'bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CartStateService } from '@services/cartStateService';

@Component({
    selector: 'app-detail-view',
    templateUrl: './detail-view.component.html',
    styleUrl: './detail-view.component.scss'
})
export class DetailViewComponent implements OnInit, OnDestroy {
    destroy$: Subject<boolean> = new Subject<boolean>();

    product: any;
    mainImage: string = '';
    registerPopup: boolean = false;
    mainImageId: number;
    subMainImageId: number;
    tselectedVariant: ProductVariantDetails;
    currentIndex = 0;
    mainImageUrl: string = '';
    colors: any[] = [];
    tselectedAvailability: any;
    // filter colors and sizes
    tcolors: string[] = [];
    tsizes: string[] = [];
    // two changes
    tcolor: string = '';
    tsize: string = '';
    tselectedSize: string = '';
    tselectedColor: string = '';
    tselectedPrice: number = 0;
    barCodeNumber: number = 0;
    tselectedOfferPrice: number = 0;
    productImages: any[] = [];
    similarProducts: AddNewProduct[] = [];
    selectedVariantId: number = 0;
    @ViewChild('thumbContainer') thumbContainer!: ElementRef;
    quantity: number = 1;
    displayVariants: any[] = [];
    isBulkProduct: boolean = false;
    imageVariantMap = new Map<number, number>();
    bulkSizes: string[] = [];
    sizeList: string[] = [];
    selectedBulkSize: string = '';
    selectedSizeValue: string = '';

    pendingCartItem: any = null;
    // ===== MODAL STATES =====
    isLoginModalOpen = false;
    isRegisterModalOpen = false;

    // ===== LOGIN =====
    loginStep: 'email' | 'otp' = 'email';
    loginEmail = '';
    loginOtp = '';
    isLoginOtpValid = false;
    loginError = '';

    // ===== REGISTRATION =====
    registerStep: 'email' | 'otp' | 'details' = 'email';
    registerEmail = '';
    registerOtp = '';
    isRegisterOtpValid = false;
    firstName = '';
    phoneNumber = '';
    registerError = '';


    // image 
    endpoint: string = ''

    // image
    imageIds: number[] = [];
    sizes: string[] = [];

    // html variable for colors and size
    color: string = '';
    size: string = '';
    selectedSize: string = '';
    selectedColor: string = '';
    selectedPrice: number = 0;
    activeImages: any = [];
    variantImageGroup = new Map<number, any[]>();
    sliderImages: any[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private appService: AppService,
        private authState: AuthStateService,
        private toastr: ToastrService,
        private config: ConfigService,
        private spinner: NgxSpinnerService,
        private router: Router,
        private cartState: CartStateService
    ) { }

    auth = {
        email: '',
        otp: '',
        firstName: '',
        phone: ''
    };

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params['product']) {
                this.product = JSON.parse(atob(params['product']));
                const variantId = params['variantId'] ? Number(params['variantId']) : null;
                this.getProductDetails(Number(this.product), variantId);
            }
        });
        this.endpoint = this.config.getConfig().END_POINT;
    }

    getProductDetails(id: number, targetVariantId?: number) {
        this.appService.getWebsiteProductById(id)
            .pipe(takeUntil(this.destroy$))
            .subscribe((product: any) => {
                const activeVariants = (product.variants || [])
                    .filter((v: any) => v.isAvailable === true);
                this.product = product;
                this.product.variants = activeVariants;
                this.isBulkProduct = product?.categoryDetails?.isBulkInsert === true;
                if (this.isBulkProduct) {
                    // bulk → no size, show all variants
                    this.buildVariantImages(activeVariants);

                    // If a specific variant was requested, select it
                    if (targetVariantId) {
                        this.selectTargetVariant(targetVariantId);
                    }
                } else {
                    const sizeSet = new Set<string>();
                    activeVariants.forEach((v: any) => {
                        if (v.size) {
                            sizeSet.add(v.size);
                        }
                    });
                    this.sizeList = Array.from(sizeSet);
                    this.sizeList.sort((a: string, b: string) => {
                        const getNumber = (size: string) => {
                            const match = size.match(/\d+/); // extract number
                            return match ? parseInt(match[0], 10) : 0;
                        };
                        return getNumber(a) - getNumber(b);
                    });

                    // If a target variant was specified, find its size and select it
                    if (targetVariantId) {
                        const targetVariant = activeVariants.find(
                            (v: any) => v.productVariantId === targetVariantId
                        );
                        if (targetVariant?.size && this.sizeList.includes(targetVariant.size)) {
                            this.selectSize(targetVariant.size);
                            // Now select the specific variant within this size
                            this.selectTargetVariant(targetVariantId);
                        } else if (this.sizeList.length) {
                            this.selectSize(this.sizeList[0]);
                        }
                    } else if (this.sizeList.length) {
                        this.selectSize(this.sizeList[0]);
                    }
                }
            });
    }

    /**
     * Select a specific variant by its ID after images are built.
     * Used when navigating from barcode search to show the exact variant.
     */
    private selectTargetVariant(variantId: number): void {
        // Find the matching image in activeImages
        const targetImage = this.activeImages.find(
            (img: any) => img.variantId === variantId
        );
        if (targetImage) {
            this.changeVariantByPrimary(targetImage);
        }
    }

    selectBulkSize(size: string) {

        this.selectedBulkSize = size;

        const sizeVariants = this.product.variants.filter(
            (v: any) => v.size === size
        );

        this.prepareBulkImages(sizeVariants);
    }

    selectSize(size: string) {

        this.selectedSizeValue = size;

        const sizeVariants = this.product.variants.filter(
            (v: any) => v.size === size && v.isAvailable === true
        );

        if (!sizeVariants.length) return;

        this.variantImageGroup.clear();
        this.activeImages = [];

        sizeVariants.forEach((variant: any) => {

            const imgs = (variant.images || [])
                .filter((img: any) => img.isActive);

            if (!imgs.length) return;

            this.variantImageGroup.set(variant.productVariantId, imgs);

            const primary = imgs.find((i: any) => i.isPrimary);

            if (primary) {
                this.activeImages.push({
                    ...primary,
                    variantId: variant.productVariantId
                });
            }
        });

        if (this.activeImages.length) {
            this.changeVariantByPrimary(this.activeImages[0]);
        }
    }

    changeVariantByPrimary(img: any) {

    this.selectedVariantId = img.variantId;

    const variantImages =
        this.variantImageGroup.get(img.variantId) || [];

    this.sliderImages = variantImages.sort(
        (a, b) => Number(b.isPrimary) - Number(a.isPrimary)
    );

    this.currentIndex = 0;

    const variant = this.product.variants.find(
        v => v.productVariantId === img.variantId
    );

    if (variant) {
        this.tselectedPrice = variant.productSrp || 0;
        this.tselectedOfferPrice = variant.productMrp || 0;
        this.barCodeNumber = variant.barcodeNumber || 0;
    }
}


    loadDefaultVariant(variants: any[]) {

        if (!variants.length) return;

        const firstVariant = variants[0];

        this.selectedVariantId = firstVariant.productVariantId;

        this.applyVariantData(firstVariant);
    }

    prepareBulkImages(variants: any[]) {

        let allImages: any[] = [];
        this.imageVariantMap.clear();

        variants.forEach(variant => {
            this.selectedVariantId = variant.productVariantId;
            const imgs = (variant.images || []).filter((i : any) => i.isActive);

            imgs.forEach((img : any) => {
                this.imageVariantMap.set(img.imageDetailsId, variant.productVariantId);
                allImages.push(img);
            });
        });

        // Remove duplicates
        const unique = new Map();
        allImages.forEach(img => unique.set(img.imageDetailsId, img));

        this.activeImages = Array.from(unique.values());

        // Primary first
        this.activeImages.sort((a : any, b: any) => Number(b.isPrimary) - Number(a.isPrimary));

        // AUTO SELECT FIRST IMAGE + PRICE
        if (this.activeImages.length > 0) {
            const firstImage = this.activeImages[0];
            this.selectImageAndVariant(firstImage.imageDetailsId);
        }
    }


    selectImageAndVariant(imageId: number) {

        this.mainImageId = imageId;

        const variantId = this.imageVariantMap.get(imageId);
        this.selectedVariantId = variantId || null;

        const variant = this.product.variants.find(
            v => v.productVariantId === variantId
        );

        if (variant) {
            this.tselectedPrice = variant.productSrp || 0;
            this.tselectedOfferPrice = variant.productMrp || 0;
            this.barCodeNumber = variant.barcodeNumber || 0;
        }
    }
    applyVariantData(variant: any) {

        this.activeImages = (variant.images || [])
            .filter(img => img.isActive)
            .sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary));

        this.mainImageId = this.activeImages.length
            ? this.activeImages[0].imageDetailsId
            : 0;

        this.tselectedPrice = variant.productSrp || 0;
        this.barCodeNumber = variant.barcodeNumber || 0;
        this.tselectedOfferPrice = variant.productMrp || 0;
    }



    variantSelected(variant: any) {

        if (this.isBulkProduct) return; // block in bulk

        this.selectedVariantId = variant.productVariantId;

        this.applyVariantData(variant);
    }


    changeMainImage(imageId: number) {

        this.mainImageId = imageId;

        // Only bulk should change variant
        if (!this.isBulkProduct) return;

        const mappedVariantId = this.imageVariantMap.get(imageId);

        if (mappedVariantId) {
            this.selectedVariantId = mappedVariantId;

            const variant = this.product.variants.find(
                v => v.productVariantId === mappedVariantId
            );

            if (variant) {
                this.tselectedPrice = variant.productSrp || 0;
                this.barCodeNumber = variant.barcodeNumber || 0;
                this.tselectedOfferPrice = variant.productMrp || 0;
            }
        }
    }

    buildVariantImages(variants: any[]) {

    this.variantImageGroup.clear();
    this.activeImages = [];

    variants.forEach((variant: any) => {

        const imgs = (variant.images || [])
            .filter((img: any) => img.isActive);

        if (!imgs.length) return;

        this.variantImageGroup.set(variant.productVariantId, imgs);

        const primary = imgs.find((i: any) => i.isPrimary);

        if (primary) {
            this.activeImages.push({
                ...primary,
                variantId: variant.productVariantId
            });
        }
    });

    if (this.activeImages.length) {
        this.changeVariantByPrimary(this.activeImages[0]);
    }
}

    getImageById(imageId: number): string {
        return imageId
            ? `${this.endpoint}/api/product/image-details/get/${imageId}`
            : 'assets/img/my-1.jpg';
    }


    onImageError(event: Event) {
        (event.target as HTMLImageElement).src = 'assets/img/my-1.jpg';
    }

    nextImage() {
    if (!this.sliderImages.length) return;

    this.currentIndex++;

    if (this.currentIndex >= this.sliderImages.length) {
        this.currentIndex = 0;
    }
}

prevImage() {
    if (!this.sliderImages.length) return;

    this.currentIndex--;

    if (this.currentIndex < 0) {
        this.currentIndex = this.sliderImages.length - 1;
    }
}

    updateFromSlider() {

        const image = this.activeImages[this.currentIndex];
        this.mainImageId = image.imageDetailsId;

        if (this.isBulkProduct) {
            const variantId = this.imageVariantMap.get(image.imageDetailsId);

            const variant = this.product.variants.find(
                v => v.productVariantId === variantId
            );

            if (variant) {
                this.selectedVariantId = variant.productVariantId;
                this.tselectedPrice = variant.productSrp || 0;
                this.tselectedOfferPrice = variant.productMrp || 0;
                this.barCodeNumber = variant.barcodeNumber || 0;
            }
        }
    }

    showPopup() {
        this.registerPopup = !this.registerPopup;
    }

    deliveryDetailForm = new UntypedFormGroup({
        customerName: new UntypedFormControl('', Validators.required),
        phoneNumber: new UntypedFormControl('', Validators.required),
        doorNo: new UntypedFormControl('', Validators.required),
        village: new UntypedFormControl(' ', Validators.required),
        street: new UntypedFormControl('', Validators.required),
        city: new UntypedFormControl('', Validators.required),
        pincode: new UntypedFormControl('', Validators.required),
        state: new UntypedFormControl('', Validators.required),
        message: new UntypedFormControl('', Validators.required)
    });

    deliveryDetailErrorForm = {
        customerName: '',
        phoneNumber: '',
        doorNo: '',
        street: '',
        city: '',
        pincode: '',
        state: ''
    };

    deliveryValidation() {
        this.deliveryDetailErrorForm.customerName = '';
        this.deliveryDetailErrorForm.phoneNumber = '';
        this.deliveryDetailErrorForm.doorNo = '';
        this.deliveryDetailErrorForm.street = '';
        this.deliveryDetailErrorForm.city = '';
        this.deliveryDetailErrorForm.pincode = '';
        this.deliveryDetailErrorForm.state = '';

        let hasError = false;

        if (this.deliveryDetailForm.get('customerName').invalid) {
            this.deliveryDetailErrorForm.customerName = 'Name is required';
            this.deliveryDetailForm.get('customerName')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('phoneNumber').invalid) {
            this.deliveryDetailErrorForm.phoneNumber = 'Phone Number required';
            this.deliveryDetailForm.get('phoneNumber')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('doorNo').invalid) {
            this.deliveryDetailErrorForm.doorNo = 'Door No is required';
            this.deliveryDetailForm.get('doorNo')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('street').invalid) {
            this.deliveryDetailErrorForm.street = 'Street is required';
            this.deliveryDetailForm.get('street')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('city').invalid) {
            this.deliveryDetailErrorForm.city = 'City is required';
            this.deliveryDetailForm.get('city')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('pincode').invalid) {
            this.deliveryDetailErrorForm.pincode = 'PinCode required';
            this.deliveryDetailForm.get('pincode')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('state').invalid) {
            this.deliveryDetailErrorForm.state = 'State is required';
            this.deliveryDetailForm.get('state')?.markAsTouched();
            hasError = true;
        }
        if (!hasError) {
            const requestBody = {
                productId: this.product.productId,
                customerName: this.deliveryDetailForm.get('customerName').value,
                phoneNumber: this.deliveryDetailForm.get('phoneNumber').value,
                doorNo: this.deliveryDetailForm.get('doorNo').value,
                village: this.deliveryDetailForm.get('village').value,
                street: this.deliveryDetailForm.get('street').value,
                city: this.deliveryDetailForm.get('city').value,
                state: this.deliveryDetailForm.get('state').value,
                pincode: this.deliveryDetailForm.get('pincode').value,
                message: this.deliveryDetailForm.get('message').value
            };
            console.log(
                'Form-value', requestBody
            );
            this.sendEnquiry(requestBody);
        }
    }

    sendEnquiry(formValue: any) {

        this.appService
            .sendEnquiry(formValue)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (data) => {
                    this.registerPopup = false;
                    this.toastr.success('Enquiry sent successfully!');
                    console.log('Enquiry sent', data);
                    this.deliveryDetailForm.controls['message'].setValue('Enquiry sent successfully!');
                    const enquiryDetails = {
                        productCode: this.product?.productCode, // Ensure product object exists
                        ...this.deliveryDetailForm.value,
                        message: 'Enquiry sent successfully!'
                    };

                    this.sendWhatsapp(enquiryDetails);
                    console.log('enquiryDetails', enquiryDetails);
                },
                (error) => {
                    this.registerPopup = false;
                    if (error?.error?.message?.includes('one enquiry per product')) {
                        this.deliveryDetailForm.controls['message'].setValue('One enquiry per product allowed');
                        const enquiryDetails = {
                            productCode: this.product?.productCode, // Ensure product object exists
                            ...this.deliveryDetailForm.value,
                            message: 'One enquiry per product allowed'
                        };

                        this.sendWhatsapp(enquiryDetails);
                        console.log('enquiryDetails', enquiryDetails);
                    } else {
                        this.toastr.error(error?.error?.message || 'Error sending enquiry!');
                    }
                    console.error('Error sending enquiry', error);
                }
            );
    }

    sendWhatsapp(msg: any) {
        const formattedMessage = encodeURIComponent(
            `Enquiry Details:
          - Product Code: ${msg.productCode}
          - Customer Name: ${msg.customerName}
          - Phone Number: ${msg.phoneNumber}
          - Address: ${msg.doorNo}, ${msg.street}, ${msg.city}, ${msg.state}, ${msg.pincode}
          - Message: ${msg.message}`
        );

        const whatsappUrl = `https://api.whatsapp.com/send?phone=919677792275&text=${formattedMessage}`;
        window.open(whatsappUrl, '_blank');
    }

    ngOnDestroy(): void {
        this.destroy$.complete();
    }

    verifyUserDetails() {

        if (!this.selectedVariantId) {
            this.toastr.warning('Please select image');
            return;
        }

        const userId = localStorage.getItem('userId');

        const cartPayload = {
            productVariantId: this.selectedVariantId,
            quantity: 1
        };

        if (userId) {
            this.addToCart(cartPayload);
        } else {
            this.pendingCartItem = cartPayload;
            this.openLoginModal();
        }
    }


    addToCart(payload: { productVariantId: number; quantity: number }) {
        this.spinner.show();

        this.appService.addToCart(payload).subscribe({
            next: () => {
                this.spinner.hide();
                this.toastr.success('Product added to cart');

                // Instantly update navbar badge
                this.cartState.updateItemQuantity(payload.productVariantId, payload.quantity);
            },
            error: () => {
                this.spinner.hide();
                this.toastr.error('Failed to add product');
            }
        });
    }

    scrollThumbs(direction: 'left' | 'right') {
  const container = this.thumbContainer?.nativeElement;
  if (!container) return;

  const scrollAmount = 200;

  container.scrollBy({
    left: direction === 'left' ? -scrollAmount : scrollAmount,
    behavior: 'smooth'
  });
}


    // ===== OPEN / CLOSE =====
    openLoginModal() {
        this.isLoginModalOpen = true;
        this.isRegisterModalOpen = false;
        document.body.classList.add('modal-open');
        localStorage.setItem('redirectAfterLogin', this.router.url);
    }

    closeLoginModal() {
        this.isLoginModalOpen = false;
        document.body.classList.remove('modal-open');
    }

    openRegisterModal() {
        this.isRegisterModalOpen = true;
        this.isLoginModalOpen = false;
        document.body.classList.add('modal-open');
    }

    closeRegisterModal() {
        this.isRegisterModalOpen = false;
        document.body.classList.remove('modal-open');
    }

    // ===== VALIDATIONS =====
    isValidEmail(email: string): boolean {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    isValidPhone(phone: string): boolean {
        const re = /^[0-9]{10}$/;
        return re.test(phone);
    }

    checkLoginOtp() { this.isLoginOtpValid = this.loginOtp.length === 4; }
    checkRegisterOtp() { this.isRegisterOtpValid = this.registerOtp.length === 4; }

    resetLogin() {
        this.loginStep = 'email';
        this.loginEmail = '';
        this.loginOtp = '';
        this.isLoginOtpValid = false;
        this.loginError = '';
    }

    resetRegister() {
        this.registerStep = 'email';
        this.registerEmail = '';
        this.registerOtp = '';
        this.isRegisterOtpValid = false;
        this.firstName = '';
        this.phoneNumber = '';
        this.registerError = '';
    }

    switchToLogin() {
        this.closeRegisterModal();
        this.openLoginModal();
    }

    switchToRegister() {
        this.closeLoginModal();
        this.openRegisterModal();
    }


    // ===== LOGIN API =====
    loginSendOtpApi() {
        if (!this.loginEmail) {
            this.loginError = 'Email is required';
            return;
        }

        this.loginError = '';
        this.spinner.show();

        this.appService.loginSendOtp({ email: this.loginEmail }).subscribe({
            next: () => {
                this.loginStep = 'otp';
                this.spinner.hide();
            },
            error: (err) => {
                this.spinner.hide();
                this.loginError = err?.error?.message || 'Failed to send OTP';
            }
        });
    }


    loginVerifyOtpApi() {
        this.spinner.show();
        this.appService.loginVerifyOtp({ email: this.loginEmail, otp: this.loginOtp }).subscribe({
            next: (res) => {
                this.spinner.hide();
                this.toastr.success('Login successful');
                localStorage.setItem('authToken', res.authHeader);
                this.authState.setUser({ userId: res.login.loginId, userType: res.login.userType });
                this.closeLoginModal();
                this.verifyUserDetails();
                const redirectUrl = localStorage.getItem('redirectAfterLogin') || '/';
                localStorage.removeItem('redirectAfterLogin');
                this.router.navigateByUrl(redirectUrl);
            },
            error: (err) => {
                this.spinner.hide();
                this.loginError = err.error.message || 'Invalid OTP'
            }
        });
    }

    // ===== REGISTRATION API =====
    registrationSendOtpApi() {
        this.spinner.show();
        this.appService.registrationSendOtp({ email: this.registerEmail }).subscribe({
            next: () => {
                this.spinner.hide();
                this.registerStep = 'otp';
            },
            error: (err) => {
                this.spinner.hide();
                this.registerError = err.error.message || 'Failed to send OTP'
            }
        });
    }

    registrationVerifyOtpApi() {
        this.spinner.show();
        this.appService.registrationVerifyOtp({ email: this.registerEmail, otp: this.registerOtp }).subscribe({
            next: () => {
                this.spinner.hide();
                this.registerStep = 'details';
            },
            error: (err) => {
                this.spinner.hide();
                this.registerError = err.error.message || 'Invalid OTP'
            }
        });
    }

    completeRegistration() {
        if (!this.firstName || !this.isValidPhone(this.phoneNumber)) {
            this.registerError = 'Enter valid first name and phone number';
            return;
        }
        this.spinner.show();
        const payload = {
            name: this.firstName,
            email: this.registerEmail || '',
            userType: 'USER',
            phoneNumber: this.phoneNumber,
            whatsappNumber: this.phoneNumber,
            password: '',
            countryCode: '91',
        };

        this.appService.saveRegistration(payload).subscribe(
            (res: any) => {
                this.spinner.hide();
                console.log('User registered', res);
                this.registerError = '';
                localStorage.setItem('authToken', res.authHeader);
                localStorage.setItem('userType', res.login.userType);
                localStorage.setItem('userId', res.login.loginId);
                this.authState.setUser({ userId: res.login.loginId, userType: res.login.userType });
                this.closeRegisterModal();
                // Auto add to cart
                // this.authService.addToCart(res.userId, []).subscribe(
                //   cartRes => console.log('Added to cart', cartRes),
                //   cartErr => console.error('Cart error', cartErr)
                // );
            },

            (err) => {
                this.spinner.hide();
                this.registerError = err.error?.message || 'Registration failed'
            }
        );
    }

    async downloadAllThumbnails(): Promise<void> {

        if (!this.product || !this.product.variants) {
            this.toastr.warning('No images available');
            return;
        }

        // Collect all unique images
        const unique = new Map<number, any>();

        this.product.variants.forEach((variant: any) => {
            const imgs = (variant.images || [])
                .filter((img: any) => img.isActive);

            imgs.forEach((img: any) => {
                unique.set(img.imageDetailsId, img);
            });
        });

        const allImages = Array.from(unique.values());

        if (!allImages.length) {
            this.toastr.warning('No images available');
            return;
        }

        this.spinner.show();

        try {

            //  Download one by one (SEQUENTIAL)
            for (let i = 0; i < allImages.length; i++) {

                const img = allImages[i];
                const imageUrl = this.getImageById(img.imageDetailsId);

                const response = await fetch(imageUrl);
                const blob = await response.blob();

                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = `${this.product?.productName || 'product'}-${i + 1}.png`;

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                window.URL.revokeObjectURL(url);

                // ⏳ Small delay (important for browser stability)
                await new Promise(resolve => setTimeout(resolve, 300));
            }

            this.toastr.success('All images downloaded successfully');

        } catch (error) {
            this.toastr.error('Some images failed to download');
        }

        this.spinner.hide();
    }
    

    goToImage(index: number) {
    this.currentIndex = index;
}

}
